import React, { useContext, useEffect, useState } from "react";
import { apiPut, apiDelete } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helper from "../../../utils/helpers";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Pagination from "pages/Pagination";
import View from "../view";
import DesView from "../descriptionViewModal";

const LiveStockOnFieldServiceList = ({
  data,
  page,
  sort,
  setSort,
  manager,
  getServiceListData,
  paginationObj,
  handlePageClick
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();
  const [details, setDetails] = useState('')
  const [viewShowModal, setViewShowModal] = useState(false)
  const [description, setDescription] = useState('')
  const [viewDesShowModal, setViewDesShowModal] = useState(false)

  const handelResponse = async (item) => {
    try {
      const payload = {
        status: item?.response
      }
      const path = `${apiPath.serviceListData}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getServiceListData('livestock-on-field-consultation')
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleUserView = (item) => {
    setDetails(item)
    setViewShowModal(true)
  }

  const handleDescriptionView = (item) => {
    setDescription(item)
    setViewDesShowModal(true)
  }

  useEffect(() => {
    getServiceListData('livestock-on-field-consultation')
  }, [ page, sort])

  return (
    <>
      <div className="pt-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full  text-sm text-left text-[#4d4c4c] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-2">
                #
              </th>

              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_USER_ID")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("USERS_FULL_NAME")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 min-w-[250px]"
              >
                <div className="flex">
                  <span>{t("O_OCCUPATION")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_MOBILE_NUMBER")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_DESCRIPTION")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (sort?.sortKey === "createdAt" && sort?.sortType === "asc") {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_CREATED_AT")} </span>
                  <span>
                    {sort?.sortKey === "createdAt" &&
                      sort?.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort?.sortKey === "createdAt" &&
                      sort?.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (sort?.sortKey === "responseDate" && sort?.sortType === "asc") {
                    setSort({
                      sortKey: "responseDate",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "responseDate",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_RESPONSE_DATE")} </span>
                  <span>
                    {sort?.sortKey === "responseDate" &&
                      sort?.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort?.sortKey === "responseDate" &&
                      sort?.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <th
                scope='col'
                className='py-3 px-2 text-center'
                onClick={() => {
                  if (sort?.sortKey === "status" && sort?.sortType === "asc") {
                    setSort({
                      sortKey: "status",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "status",
                      sortType: "asc",
                    });
                  }
                }}
                >
                  {t('O_STATUS')}
                  <span>
                    {sort?.sortKey === "status" &&
                      sort?.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort?.sortKey === "status" &&
                      sort?.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </th>
              )}
              {(manager?.add || user?.role === "admin") && (
                <>
                  <th scope="col" className="py-3 px-2 text-center">
                    {t("O_ACTION")}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-2 px-2 border-r">
                    {item?.userDetails?.userUniqueId}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {Capitalize(item?.firstName) + ' ' + item?.lastName}
                  </td>
                  <td className="py-2 px-2 border-r">{item?.userDetails?.occupation?.map((item) => item?.label).join(', ')}</td>
                  <td className="py-2 px-2 border-r">{item?.countryCode + item?.mobile}</td>
                  <td className="py-2 px-2 border-r">
                    {(item?.description). slice(0,50)}{item?.description?.length > 50 && <span className='text-black cursor-pointer' onClick={()=> handleDescriptionView(item?.description)}> {t('O_READ_MORE')}</span>}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {dayjs(item?.createdAt).format("lll")}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {item?.responseDate && dayjs(item?.responseDate).format("lll")}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>{item?.status === 'confirmed' ? <span className='text-green-500'>Confirmed</span> : item?.status === 'pending' ? <span className='text-yellow-500'>Pending</span> : <span className='text-red-500'>Rejected</span>}</td>
                  <td className="py-2 px-2 border-l">
                    <div className="">
                      <ul className="flex justify-center items-center">
                      {(manager?.add || user?.role === "admin") && (
                          <Link
                            title={t('O_VIEW')}
                            className="text-danger ml-2"
                            onClick={()=> handleUserView(item)}
                          >
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                          </Link>
                        )}
                        {(manager?.add || user?.role === "admin") && item?.status === 'pending' && (
                          <>
                          <span className="p-2 text-white rounded-lg ml-2 bg-green-500 cursor-pointer" onClick={() => helper.alertFunctionService(`Are you sure you want to confirm this appointment ?`,{...item, response: 'confirmed'},handelResponse)}>
                            Confirm
                          </span>
                          <span className="p-2 text-white rounded-lg ml-2 bg-red-500 cursor-pointer" onClick={() => helper.alertFunctionService(`Are you sure you want to reject this appointment ?`,{...item, response: 'rejected'},handelResponse)}>
                            Reject
                          </span>
                          </>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(data) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
    {paginationObj?.totalItems ? (<Pagination
      handlePageClick={handlePageClick}
      options={paginationObj}
      page={page}
    />) : null}
    {viewShowModal ? (
        <View
          setViewShowModal={setViewShowModal}
          details={details}
        />
      ) : null}
      {viewDesShowModal ? (
        <DesView
          setViewDesShowModal={setViewDesShowModal}
          description={description}
        />
      ) : null}
    </>
  );
};

export default LiveStockOnFieldServiceList;
